// Keep this list explicit. Using require.context here would eagerly include every
// translation file in the initial application bundle.
export const SUPPORTED_LOCALES = [
  "ar",
  "de",
  "en",
  "es",
  "fr",
  "hi",
  "id",
  "it",
  "ja",
  "ko",
  "nl",
  "pl",
  "pt",
  "tr",
  "uk",
  "zh-CN",
];

export function buildLocaleCookiePaths(locales) {
  return [...locales.map(locale => `/${locale}/list`), ...locales.map(locale => `/${locale}`), "/"];
}
